import Checkbox from './components/Checkbox';
export default Checkbox;
//# sourceMappingURL=index.js.map